/* RIMINIWOOD — front-end behaviour. Progressive enhancement only. */
(function () {
  'use strict';
  document.documentElement.classList.remove('no-js');
  // QA capture mode: ?shot=1 caps viewport-relative heights so a tall headless
  // window can render the whole page in one pass.
  if (/[?&]shot=/.test(location.search)) document.documentElement.classList.add('shotmode');
  // QA overflow probe: ?ovf=1 reports horizontal overflow and its widest offenders
  // into the document title, so a headless --dump-dom pass can read it.
  if (/[?&]ovf=/.test(location.search)) {
    window.addEventListener('load', function () {
      var de = document.documentElement, vw = de.clientWidth, bad = [];
      var all = document.querySelectorAll('body *');
      for (var i = 0; i < all.length; i++) {
        var r = all[i].getBoundingClientRect();
        if (r.width === 0) continue;
        if (r.right > vw + 1 || r.left < -1) {
          bad.push(all[i].tagName.toLowerCase() + '.' + (all[i].className || '').toString().split(' ')[0] +
                   '@' + Math.round(r.left) + '..' + Math.round(r.right));
          if (bad.length > 6) break;
        }
      }
      document.title = 'OVF ' + vw + '/' + de.scrollWidth + ' :: ' + (bad.join(' | ') || 'clean');
    });
  }

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- reveal on scroll ---------- */
  (function reveal() {
    var els = $$('.rv');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        var sibs = el.parentElement ? $$('.rv', el.parentElement) : [];
        var i = sibs.indexOf(el);
        el.style.setProperty('--d', (i > 0 ? Math.min(i, 6) * 80 : 0) + 'ms');
        el.classList.add('is-in');
        io.unobserve(el);
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (e) { io.observe(e); });
  })();

  /* ---------- header ---------- */
  (function header() {
    var hdr = $('.hdr');
    if (!hdr) return;
    var last = -1;
    function onScroll() {
      var y = window.scrollY > 40;
      if (y !== last) { hdr.classList.toggle('is-solid', y); last = y; }
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  })();

  /* ---------- mobile menu ---------- */
  (function menu() {
    var mm = $('.mm'), open = $('.burger'), close = $('.mm__close');
    if (!mm || !open) return;
    function set(on) {
      mm.classList.toggle('is-open', on);
      open.setAttribute('aria-expanded', String(on));
      document.body.style.overflow = on ? 'hidden' : '';
      if (on) { var f = mm.querySelector('a'); if (f) f.focus(); } else { open.focus(); }
    }
    open.addEventListener('click', function () { set(true); });
    if (close) close.addEventListener('click', function () { set(false); });
    mm.addEventListener('click', function (e) { if (e.target.tagName === 'A') set(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && mm.classList.contains('is-open')) set(false); });
  })();

  /* ---------- toast ---------- */
  var toastEl = null, toastT = null;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    requestAnimationFrame(function () { toastEl.classList.add('is-on'); });
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2800);
  }

  /* ---------- cart ---------- */
  var KEY = 'rw_cart_v1';
  // localStorage can be unavailable (private mode, blocked storage). Keep an
  // in-memory copy so the bag still works for the length of the visit.
  var mem = null;
  function read() {
    if (mem) return mem;
    try { mem = JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { mem = []; }
    return mem;
  }
  function write(c) {
    mem = c;
    try { localStorage.setItem(KEY, JSON.stringify(c)); } catch (e) {}
    paint();
  }
  // Same shape as the server-rendered prices: 1.000 EUR
  function money(n) { return new Intl.NumberFormat('it-IT', { maximumFractionDigits: 0, useGrouping: 'always' }).format(n) + ' EUR'; }

  function paint() {
    var cart = read();
    var n = cart.reduce(function (a, i) { return a + i.qty; }, 0);
    $$('.cart-count').forEach(function (b) { b.textContent = n; b.style.display = n ? '' : 'none'; });
    var body = $('.drawer__body'), ft = $('.drawer__ft');
    if (!body) return;
    var strings = window.RW_STRINGS || {};
    if (!cart.length) {
      body.innerHTML = '<p class="drawer__empty">' + (strings.cartEmpty || 'La borsa e vuota.') + '</p>';
      if (ft) ft.hidden = true;
      return;
    }
    if (ft) ft.hidden = false;
    body.innerHTML = cart.map(function (i, ix) {
      return '<div class="citem">' +
        '<img src="' + i.img + '" alt="" loading="lazy">' +
        '<div><div class="citem__t">' + i.title + '</div>' +
        '<div class="citem__m">' + (i.variant ? i.variant + ' · ' : '') + (strings.oneOf || 'Pezzo unico') + '</div>' +
        '<button class="citem__rm" data-rm="' + ix + '">' + (strings.remove || 'Rimuovi') + '</button></div>' +
        '<div class="citem__m">' + money(i.price) + '</div></div>';
    }).join('');
    var total = cart.reduce(function (a, i) { return a + i.price * i.qty; }, 0);
    var tot = $('.crow b'); if (tot) tot.textContent = money(total);
    $$('[data-rm]', body).forEach(function (b) {
      b.addEventListener('click', function () {
        var c = read(); c.splice(parseInt(b.dataset.rm, 10), 1); write(c);
      });
    });
  }

  function drawer(on) {
    var d = $('.drawer'), s = $('.scrim');
    if (!d) return;
    d.classList.toggle('is-open', on);
    if (s) s.classList.toggle('is-on', on);
    d.setAttribute('aria-hidden', String(!on));
    document.body.style.overflow = on ? 'hidden' : '';
    if (on) { var c = $('.drawer__close'); if (c) c.focus(); }
  }

  $$('[data-cart-open]').forEach(function (b) { b.addEventListener('click', function () { drawer(true); }); });
  var sc = $('.scrim'); if (sc) sc.addEventListener('click', function () { drawer(false); });
  var dc = $('.drawer__close'); if (dc) dc.addEventListener('click', function () { drawer(false); });
  document.addEventListener('keydown', function (e) {
    var d = $('.drawer');
    if (e.key === 'Escape' && d && d.classList.contains('is-open')) drawer(false);
  });

  $$('[data-add]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrap = btn.closest('[data-product]') || document;
      var sizeBtn = wrap.querySelector('.size[aria-pressed="true"]');
      var needsSize = !!wrap.querySelector('.size');
      var strings = window.RW_STRINGS || {};
      if (needsSize && !sizeBtn) { toast(strings.pickSize || 'Scegli una taglia'); return; }
      var cart = read();
      var item = {
        id: btn.dataset.add,
        title: btn.dataset.title,
        price: parseFloat(btn.dataset.price),
        img: btn.dataset.img,
        variant: sizeBtn ? sizeBtn.textContent.trim() : '',
        qty: 1
      };
      if (cart.some(function (i) { return i.id === item.id && i.variant === item.variant; })) {
        toast(strings.already || 'Gia nella borsa: e un pezzo unico');
        drawer(true);
        return;
      }
      cart.push(item); write(cart);
      toast(strings.added || 'Aggiunto alla borsa');
      drawer(true);
    });
  });

  paint();

  /* ---------- size selector ---------- */
  $$('.sizes').forEach(function (g) {
    $$('.size', g).forEach(function (b) {
      b.addEventListener('click', function () {
        $$('.size', g).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        b.setAttribute('aria-pressed', 'true');
      });
    });
  });

  /* ---------- accordions ---------- */
  $$('.acc__h').forEach(function (h) {
    h.addEventListener('click', function () {
      var open = h.getAttribute('aria-expanded') === 'true';
      h.setAttribute('aria-expanded', String(!open));
      var p = document.getElementById(h.getAttribute('aria-controls'));
      if (p) p.classList.toggle('is-open', !open);
    });
  });

  /* ---------- filmstrip ---------- */
  $$('.strip').forEach(function (strip) {
    var rail = $('.strip__rail', strip);
    var prev = $('[data-strip="prev"]', strip);
    var next = $('[data-strip="next"]', strip);
    if (!rail || !prev || !next) return;
    function step() { var c = rail.querySelector('.look'); return c ? c.offsetWidth : 320; }
    function sync() {
      prev.disabled = rail.scrollLeft < 8;
      next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 8;
    }
    prev.addEventListener('click', function () { rail.scrollBy({ left: -step() * 2, behavior: reduce ? 'auto' : 'smooth' }); });
    next.addEventListener('click', function () { rail.scrollBy({ left: step() * 2, behavior: reduce ? 'auto' : 'smooth' }); });
    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  /* ---------- catalogue filters + sort ---------- */
  (function catalogue() {
    var grid = $('[data-grid]');
    if (!grid) return;
    var items = $$('[data-item]', grid);
    var counted = items.filter(function (el) { return !el.hasAttribute('data-nocount'); });
    var chips = $$('.chip[data-filter]');
    var sort = $('[data-sort]');
    var count = $('.filters__count');
    var active = 'all';

    function apply() {
      var shown = 0;
      items.forEach(function (el) {
        var ok = active === 'all' || (el.dataset.cat || '').split(' ').indexOf(active) > -1;
        el.hidden = !ok;
        if (ok && !el.hasAttribute('data-nocount')) shown++;
      });
      if (count) {
        var t = (window.RW_STRINGS && window.RW_STRINGS.pieces) || 'pezzi';
        count.textContent = shown + ' ' + t;
      }
    }
    function doSort(mode) {
      var arr = items.slice();
      arr.sort(function (a, b) {
        var pa = parseFloat(a.dataset.price || '0'), pb = parseFloat(b.dataset.price || '0');
        var oa = parseInt(a.dataset.order || '0', 10), ob = parseInt(b.dataset.order || '0', 10);
        if (mode === 'price-asc') return (pa || 1e9) - (pb || 1e9);
        if (mode === 'price-desc') return (pb || -1) - (pa || -1);
        return oa - ob;
      });
      arr.forEach(function (el) { grid.appendChild(el); });
      $$('[data-nocount]', grid).forEach(function (el) { grid.appendChild(el); });
    }
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        chips.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        c.setAttribute('aria-pressed', 'true');
        active = c.dataset.filter;
        apply();
      });
    });
    if (sort) sort.addEventListener('change', function () { doSort(sort.value); });
    apply();
  })();

  /* ---------- enquiry / contact forms ---------- */
  $$('form[data-demo]').forEach(function (f) {
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var strings = window.RW_STRINGS || {};
      toast(strings.sent || 'Richiesta inviata. Ti rispondiamo entro un giorno lavorativo.');
      f.reset();
    });
  });

  /* ---------- checkout (mockup) ---------- */
  var co = $('[data-checkout]');
  if (co) co.addEventListener('click', function () {
    var strings = window.RW_STRINGS || {};
    toast(strings.checkout || 'Checkout dimostrativo: nessun pagamento reale.');
  });
})();
